// T019 + T022 — yup schemas for the issue and revoke admin forms.
import * as yup from "yup";

const startOfTomorrow = (): Date => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 1);
  return d;
};

export const issueCreditSchema = yup.object({
  amount: yup
    .number()
    .typeError("Amount is required.")
    .required("Amount is required.")
    .moreThan(0, "Amount must be greater than zero."),
  // Compute the floor at validation time, not module load — long-lived tabs
  // would otherwise keep yesterday's threshold after midnight rollover.
  expires_at: yup
    .date()
    .typeError("Expiration date is required.")
    .required("Expiration date is required.")
    .test("future-date", "Expiration must be in the future.", (value) => {
      if (!value) return true; // handled by .required()
      return value >= startOfTomorrow();
    }),
  note: yup
    .string()
    .trim()
    .required("A note explaining the issuance is required.")
    .min(1, "A note explaining the issuance is required."),
});

export const revokeCreditSchema = yup.object({
  amount: yup
    .number()
    .typeError("Amount is required.")
    .required("Amount is required.")
    .moreThan(0, "Amount must be greater than zero."),
  note: yup
    .string()
    .trim()
    .required("A note explaining the revocation is required.")
    .min(1, "A note explaining the revocation is required."),
  target_batch_id: yup.string().nullable().optional(),
});

export type IssueCreditFormValues = yup.InferType<typeof issueCreditSchema>;
export type RevokeCreditFormValues = yup.InferType<typeof revokeCreditSchema>;
